import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from '@chakra-ui/react';

import Tip from '@/components/Tip/Tip';
import IRootPage from '@/types/IRootPage';
import { FormControl, FormLabel, Heading, Input } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface IProps {
	isLoading: boolean;
	form: UseFormReturn<IRootPage>;
	submitForm: () => void;
}

export default function SectionInfo(props: IProps) {
	const { t } = useTranslation();

	return (
		<Accordion allowToggle mt="2" background="white" borderRadius="md" borderColor="gray.100" borderWidth={1}>
			<AccordionItem overflow="hidden" borderRadius="md" border="none">
				<AccordionButton>
					<Heading as="h2" size="sm" p="4">
						{t('Name and description')}
					</Heading>
					<AccordionIcon ml="auto" />
				</AccordionButton>
				<AccordionPanel p={4} borderTopWidth={1} borderTopColor="gray.100" borderTopStyle="solid">
					<Tip>
						{t('Add a name and a description to your page so that your customers know what they will find on it.')}
					</Tip>

					<FormControl isDisabled={props.isLoading}>
						<FormLabel htmlFor="title">{t('Name')}</FormLabel>
						<Input
							variant="filled"
							id="title"
							{...props.form.register('name')}
							type="text"
							onBlur={props.submitForm}
							placeholder={t('Write a name for your link group here')}
						/>
					</FormControl>

					<FormControl mt="4" isDisabled={props.isLoading}>
						<FormLabel htmlFor="description">{t('Description')}</FormLabel>
						<Input
							variant="filled"
							id="description"
							{...props.form.register('description')}
							type="text"
							onBlur={props.submitForm}
							placeholder={t('Write a description here')}
						/>
					</FormControl>

					<FormControl mt="4" isDisabled={props.isLoading}>
						<FormLabel htmlFor="image">{t('Image')}</FormLabel>
						<Input
							variant="filled"
							id="image"
							{...props.form.register('imageUrl')}
							type="text"
							onBlur={props.submitForm}
							placeholder={t('Image url')}
						/>
					</FormControl>
				</AccordionPanel>
			</AccordionItem>
		</Accordion>
	);
}
